export enum SORT {
    NEUTRAL = '',
    DESC = 'DESC',
    ASC = 'ASC',
}
